import { render, staticRenderFns } from "./IconPeople.vue?vue&type=template&id=5cf0492e&"
import script from "./IconPeople.vue?vue&type=script&lang=ts&"
export * from "./IconPeople.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports